import useLaunchDarkly from 'hooks/useLaunchDarkly';
import React, { forwardRef } from 'react';

const withLaunchDarkly = WrappedComponent =>
  forwardRef((props, ref) => {
    const flags = useLaunchDarkly();
    return <WrappedComponent ref={ref} flags={flags} {...props} />;
  });

export default withLaunchDarkly;
